jQuery(function ($) {
  var $sectionRegister = $(".section-register input");
  var $userEmail = $sectionRegister.filter("#user_email");

  $userEmail.removeClass( "textbox" ).addClass('form-control').attr("placeholder", "利用規約に同意して会員登録を続ける");
  $userEmail.after('<div class="well well-bg-dark-gray well-policy"></div>');

  $( ".well-policy" ).load("../wp-content/themes/fc-site/inc/policy.php");
  $sectionRegister.filter(".btn-register").val('利用規約に同意して会員登録を続ける');
});
